import { gql } from "graphql-tag";

export const manualFragmentsForExport = gql`
  #
  # ───────────────────────────
  #  MANUAL FRAGMENTS
  # ───────────────────────────
  #

  # If you want a small fragment for product_Entry:
  fragment ProductEntryFields on product_Entry {
    id
    title
    userTitle
    typeHandle
    sectionHandle
    pageLayoutType
    productCategory {
      id
      title
      ... on productCategories_Category {
        role
      }
    }
    productFeatures {
      id
      title
    }
    productIcon {
      uid
      url
      width
      height
      focalPoint
      hasFocalPoint
    }
    translationImportTimestamp
    scopedVariables: variables {
      ...VariableEntryFields
    }
  }

  # Similarly, if you want a fragment for chapter_Entry:
  fragment ChapterEntryFields on chapter_Entry {
    id
    title
    userTitle
    typeHandle
    sectionHandle
    translationImportTimestamp

    topicArticles {
      sortOrder
      typeHandle
      sectionHandle
      ... on articleLongformComposableEntries_Entry {
        ...ArticleLongformComposableEntriesFields
      }
      ... on articleWithSteps_Entry {
        ...ArticleWithStepsFields
      }
      ... on articleLongform_Entry {
        ...ArticleLongformFields
      }
      ... on articleStepByStepComposableEntries_Entry {
        ...ArticleStepByStepComposableEntriesFields
      }
    }
  }
`;

export default manualFragmentsForExport;
